import { useGetCodeFrameQuery } from 'hooks/queries/code-frames/useGetCodeFrameQuery';
import { useLocation } from 'react-router-dom';

import DevSandboxSkeleton from 'components/DevSandbox/DevSandboxSkeleton';
import { SEO } from 'components/SEO';

import CodeFramePlayground from './CodeFramePlayground';

const CodeFrameHub = () => {
  const { pathname } = useLocation();
  const hasTabInUrl =
    pathname.includes('browser') ||
    pathname.includes('summary') ||
    pathname.includes('merlin') ||
    pathname.includes('comments') ||
    pathname.includes('explore');
  const tabScreenName = pathname.split('/').pop();
  const solutionUrl = hasTabInUrl
    ? pathname.replace(`/${tabScreenName}`, '')
    : pathname;

  const { data, isPending } = useGetCodeFrameQuery({
    solution_url: solutionUrl,
  });

  if (!data || isPending) {
    return <DevSandboxSkeleton loadingText="Loading code frame..." />;
  }

  return (
    <>
      <SEO
        title={`BigDevSoon | ${data.title} Code Frame`}
        url={`${process.env.REACT_APP_SITE_URL}code-frames/${data.user.screen_name}/${data.screen_name}`}
        image={data.screenshot_url}
      />
      <CodeFramePlayground codeFrame={data} />
    </>
  );
};

export default CodeFrameHub;
